import React from "react"
import Link from "next/link"
import CheckPoint from "../../components/CheckPoint"

import { useTranslation, useLanguageQuery } from "next-export-i18n"

const Header = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()

  return (
    <div className="hero w-full bg-lightBlue relative overflow-hidden h-full z-10">
      <div className="mt-20 xl:mt-0 "></div>
      <EmergencyContainer>
        <EmergencyBanner className="bg-red-500">
          {t("if_this_is_an_emergency")}
        </EmergencyBanner>
        <EmergencyBanner className="bg-yellow-300 font-semibold">
          {t("for_controlled_substance_renewals")}
        </EmergencyBanner>
      </EmergencyContainer>
      <div className="flex  max-w-7xl header mx-auto md:pb-14 px-4 md:p-10 mt-80 md:mt-48 xl:mt-20">
        <div className="self-auto md:self-center">
          <div className="grid  grid-cols-1 md:grid-cols-2 gap-14 relative">
            <div className="">
              <div>
                <h2 className="text-woundTextDark text-2xl md:text-2xl xl:text-4xl pb-3  text-center md:text-left font-semibold   ">
                  {t("speak_to_a_nurse_practitioner")}
                </h2>
                <p className=" text-lg xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                  {t("the_episodic_access_to_virtual_care_clinic")}
                </p>
                {query?.lang == "en" && (
                  <p className=" text-lg xl:text-xl pb-10 md:mr-12 text-center md:text-left font-normal  ">
                    {t("header_copy1")}
                    <a
                      className="font-semibold hover:text-secondary"
                      href="https://www.ontariohealth.ca/about-us/our-programs/ontario-health-regions/north-west-region"
                      target="_blank"
                    >
                      {" "}
                      Ontario Health North West{" "}
                    </a>
                    {t("header_copy2")}
                  </p>
                )}
                {query?.lang == "fr" && (
                  <p className=" text-lg xl:text-xl pb-14 md:mr-12 text-center md:text-left font-normal  ">
                    {t("header_copy1")}
                    <a
                      className="font-semibold hover:text-secondary"
                      href="https://www.ontariohealth.ca/fr/a-propos-de-nous/nos-programmes/regions-de-sante-ontario/region-nord-ouest"
                      target="_blank"
                    >
                      {" "}
                      Santé Nord Ouest Ontario{" "}
                    </a>
                    {t("header_copy2")}
                  </p>
                )}

                <div className="flex justify-center md:justify-start">
                  <Link
                    href={{
                      pathname: t(
                        "register_for_a_phone_or_video_call_here.route"
                      ),
                      query: query,
                    }}
                  >
                    <a className="text-sm text-center lg:text-lg  font-semibold text-white hover:text-white bg-primary transition-all hover:bg-secondary hover:shadow-lg rounded-full px-5 py-3 md:px-10 md:py-3.5 cursor-pointer">
                      {t("register_for_a_phone_or_video_call_here.text")}
                    </a>
                  </Link>
                </div>
              </div>
            </div>
            <div className="pb-12 md:pb-0">
              {/* <h1 className="text-primary text-2xl  font-semibold">Service</h1> */}
                <h2 className="text-woundTextDark text-2xl md:text-2xl xl:text-4xl pb-3  text-center md:text-left font-semibold   ">
                {t("who_we_serve")}
              </h2>
              {query?.lang == "en" && (
                <p className="text-base font-normal text-grey pb-4 ">
                  {t("service_copy1")}
                  <a
                    className="font-semibold hover:text-secondary"
                    href="https://www.ontariohealth.ca/about-us/our-programs/ontario-health-regions/north-west-region"
                    target="_blank"
                  >
                    {" "}
                    Ontario Health North West{" "}
                  </a>
                  {t("service_copy2")}
                </p>
              )}
              {query?.lang == "fr" && (
                <p className="text-base font-normal text-grey pb-4 ">
                  {t("service_copy1")}
                  <a
                    className="font-semibold hover:text-secondary"
                    href="https://www.ontariohealth.ca/fr/a-propos-de-nous/nos-programmes/regions-de-sante-ontario/region-nord-ouest"
                    target="_blank"
                  >
                    {" "}
                    Santé Nord Ouest Ontario{" "}
                  </a>
                  {t("service_copy2")}
                </p>
              )}

              {t("service_data").map((item, index) => {
                return (
                  <div key={index}>
                    <CheckPoint title={item.title} />
                  </div>
                )
              })}

              <p className="text-base md:pt-4 font-normal text-grey  ">
                {t("we_work_with_hospitals")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header

const EmergencyContainer = (props) => (
  <div
    style={{
      width: "100%",
      textAlign: "center",
      position: "absolute",
      zIndex: 49,
    }}
  >
    {props.children}
  </div>
)

const EmergencyBanner = (props) => (
  <div
    style={{
      padding: "5px",
    }}
    className={props.className}
  >
    {props.children}
  </div>
)

// const data = [
//   {
//     title: (t("who_we_serve")),
//   },
//   {
//     title:
//       "Patients with health concerns that are not life or limb threatening",
//   },
//   { title: "Patients with or without a primary care provider" },
// ]
